import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/services/login.service';
import { environment } from '../../../environments/environment';


@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.scss']
})
export class InicioComponent implements OnInit {
  enviroment = environment.BASE_URL;
  input;
  respuestaGet:any;
  public errorMsg:string;
  datosCliente:any;


  error = 0;
  constructor(private router: Router, private _loginService : LoginService, private _get:LoginService) { }

  ngOnInit(): void {
    this.input = {
      username: '',
      password: ''
    }

    this.getTypeOfUser();
  }

  onLogin(){
    this.error = 0;
    this._loginService.loginUser(this.input).subscribe(
      response => {
        this._loginService.guardarToken(response.token);
        // console.log('local storage \n' + localStorage.getItem('token')); 
        this.getTypeOfUser();
      },
      error =>{
        this.error = 1;
        this.errorMsg = 'No hemos podido iniciar sesión con las credenciales proporcionadas';

        console.log('error: ', error)
      }
    )
  }

  getTypeOfUser(){
    this._get.getDataCliente().subscribe(
      data => {
        this.respuestaGet = data;
        if(this.respuestaGet.success){
          this.datosCliente = this.respuestaGet.content;
          if(this.datosCliente.is_staff == false){
            this.router.navigate(['elegir-paquete']);
          }else{
            if(this.datosCliente.tipo == 1){
              this.router.navigate(['clientes']);
            }else  if(this.datosCliente.tipo == 2){
              this.router.navigate(['grupos']);
            }
            
            // this.router.navigate(['simulador']);
          }
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error))
  }

}
